import { ExternalLink } from "@/components/ExternalLink";
import { siteLinks, trustCopy } from "@/config/branding";

const legalLinks = [
  { label: "Privacy", href: siteLinks.privacy },
  { label: "Terms", href: siteLinks.terms },
  { label: "Legal", href: siteLinks.legal },
  { label: "Cookies", href: siteLinks.cookies },
  { label: "DPA", href: siteLinks.dpa },
] as const;

interface LegalFooterProps {
  /** Show the privacy/trust statement above the link row. */
  showTrustStatement?: boolean;
  className?: string;
}

export function LegalFooter({ showTrustStatement = true, className }: LegalFooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer className={className}>
      {showTrustStatement ? <p>{trustCopy.privacyStatement}</p> : null}
      <p className={showTrustStatement ? "mt-2" : undefined}>
        <span>© {year} </span>
        <ExternalLink href={siteLinks.companyWebsite} className="underline hover:text-ink">
          RequirementONE
        </ExternalLink>
        <span className="text-ink-muted"> · </span>
        {legalLinks.map((link, index) => (
          <span key={link.label}>
            {index > 0 ? <span className="text-ink-muted"> · </span> : null}
            <ExternalLink href={link.href} className="underline hover:text-ink">
              {link.label}
            </ExternalLink>
          </span>
        ))}
      </p>
    </footer>
  );
}
